<template>
  <!-- contenedor main -->
  <div
    class="borde_custom_1 relative overflow-hidden w-full h-full group border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
    :class="{ 'cursor-pointer': !!data.link }"
    :role="data.link ? 'link' : undefined"
    :tabindex="data.link ? 0 : undefined"
    @click="on_card_click"
    @keydown.enter.prevent="on_card_key"
    @keydown.space.prevent="on_card_key"
  >
    <!-- Imagen de fondo -->
    <img
      v-if="data.backgroundimage"
      :src="data.backgroundimage"
      class="borde_custom_2 absolute inset-0 w-full h-full object-cover"
      alt="background"
    />

    <!-- Capa de color con hover -->
    <div class="absolute inset-0 bg-white bg-opacity-95 group-hover:bg-ROJO_LEON group-hover:bg-opacity-95 transition duration-500"></div>

    <!--contenedor padre-->
    <div
      class="relative w-full h-full flex gap-2 md:gap-2 p-4 md:p-4 items-center transition duration-500 group-hover:text-white text-GRIS_LEON"
      :class="data.cont_padre"
    >
      <!--imagen_1-->
      <img :class="[data.tam_imagen_1, 'transition duration-700 group-hover:scale-105']" :src="data.image" />

      <!--contenedor inferior-->
      <div :class="[data.cont_inferior, 'flex flex-col w-auto md:w-full']">
        <h3 class="md:text-lg font-bold text-balance reducir_line">{{ data.title }}</h3>

        <img
          v-if="data.imagen_inferior"
          class="transition duration-500 filter group-hover:invert group-hover:brightness-0 w-[60%] md:w-[80%] aspect-auto"
          :src="data.imagen_inferior"
          alt="logo"
        />

        <p v-if="data.descriptionBold!==''" class="font-bold text-base">{{ data.descriptionBold }}</p>
        <p class="text-base">{{ data.description }}</p>

        <NuxtLink
          v-if="data.link"
          :href="data.link"
          @click.stop
          :class="[
            data.estilo_boton_link,
            'flex justify-center items-center border py-1 gap-1 md:gap-2 px-2 font-semibold rounded-lg text-sm w-fit'
          ]"
        >
          {{ data.buttonText }}

          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <mask id="mask0_1216_394" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1216_394)">
              <path d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z" fill="currentColor" />
            </g>
          </svg>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: Object
  })

  const is_external = (url) => /^https?:\/\//i.test(url)

  const ir_a_link = async () => {
    if (!props.data?.link) return

    const link = props.data.link
    await navigateTo(link, is_external(link) ? { external: true } : undefined)
  }

  const on_card_click = async (e) => {
    if (!props.data?.link) return

    // Si el click ocurrió sobre un link (<a>) dentro del componente, no navegues doble
    const el = e?.target
    if (el && el.closest && el.closest('a')) return

    await ir_a_link()
  }

  const on_card_key = async () => {
    if (!props.data?.link) return
    await ir_a_link()
  }
</script>

<style scoped>
  .borde_custom_1 {
    border-radius: 1rem;
    box-shadow: inset 0 0 0 2px #E5E7EB;
  }

  .borde_custom_2 {
    border-radius: 1.1rem;
  }

  .reducir_line{
    line-height: normal;
  }
</style>